<template lang="pug">
v-layout(wrap)
  v-flex(lg8, md8, xs12)
    v-autocomplete(
      v-model="account",
      :disabled="disabled",
      :readonly="readonly",
      :label="label ? label : 'No. Rekening'",
      :items="list",
      :item-text="text",
      item-value="accountNumber",
      @change="onSelect",
      return-object
    )
      template(slot="selection", slot-scope="data") ( {{ data.item.accountTypeName }} ) {{ data.item.accountNumber | accountformat }} - {{ data.item.accountName }}
  v-flex(lg4, md4, xs12, v-if="!hideBalance")
    v-text-field.right-component(
      v-model="balance",
      :loading="loading",
      readonly,
      label="Saldo Rekening"
    )
</template>
<script>
export default {
  name: "FSelectAccountBalance",
  props: [
    "value",
    "default",
    "disabled",
    "readonly",
    "label",
    "access",
    "hideBalance",
  ],
  data() {
    return {
      account: null,
      listAccount: [],
      balance: null,
      loading: false,
    };
  },
  mounted() {
    this.doInit(
      this.value
        ? this.value
        : this.listAccount.length > 0
        ? this.listAccount[0]
        : null
    );
  },
  computed: {
    list() {
      return this.listAccount
        .sort((a, b) => a.mainAccount - b.mainAccount)
        .sort((c, d) => c.accountType - d.accountType);
    },
  },
  watch: {
    default(val) {
      this.account = val
        ? this.getObjectAccount(val)
        : this.listAccount.length > 0
        ? this.listAccount[0]
        : null;
      this.$emit("account", this.getObjectAccount(val));
    },
    account(val) {
      this.onSelect();
    },
  },
  created() {
    this.$session.userDetail().then((item) => {
      let accounts = item.corporate.corporateGroup.accounts || [];
      if (this.access) {
        if (accounts.length > 0) {
          this.listAccount = accounts.filter((f) => f.accessTransaction);
        } else {
          this.listAccount = accounts;
        }
      } else {
        this.listAccount = accounts;
      }
      this.account = accounts ? this.list[0] : null;
    });
  },
  methods: {
    text: (item) =>
      "(" +
      item.accountTypeName +
      ") " +
      item.accountNumber +
      " - " +
      item.accountName,
    getObjectAccount(item) {
      this.listAccount.map((acc) => {
        if (acc.accountNumber == item) {
          this.account = acc;
        }
      });
    },
    doInit(values) {
      this.account = values ? values : null;
      this.getBalance();
    },
    onSelect() {
      this.$emit("input", this.account);
      this.$emit("select", this.account);
      this.getBalance();
    },
    getBalance() {
      if (this.account) {
        this.balance = this.$options.filters.decimalformat(0.0);
        this.loading = true;
        this.$http
          .get("api/banking/balance-account", {
            params: {
              accountNumber: this.account.accountNumber,
            },
          })
          .then(
            (success) => {
              this.balance = this.$options.filters.decimalformat(
                success.data.lastBalance
              );
              this.$emit("inquiryBalance", success.data);
            },
            (err) => {
              this.balance = this.$options.filters.decimalformat(0.0);
            }
          )
          .finally(() => (this.loading = false));
      } else {
        this.balance = this.$options.filters.decimalformat(0.0);
      }
    },
  },
};
</script>